import { componentName, NewPasswordClass } from './NewPasswordClass';
import '../descope-text-field';
import '../descope-password';
import '../descope-policy-validation';
import './descope-new-password-internal';

customElements.define(componentName, NewPasswordClass);

export { NewPasswordClass, componentName };
